import { OverlayOptionsType } from './types';

export const DEFAULT_OPTS: OverlayOptionsType = {
  enterLock: true,
};
